module.exports = __webpack_public_path__ + "static/media/karista-clients.f8643d49.svg";